import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';

import { PaginationControlsComponent } from './pagination-controls.component';

@NgModule({
    declarations: [PaginationControlsComponent],
    exports: [PaginationControlsComponent],
    imports: [CommonModule, DisabledModule],
})
export class PaginationControlsModule {}
